const COMMENTS = [
  {
    id: 1,
    name: '漫画小王子',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20cartoon%20avatar%20of%20a%20boy%20with%20glasses%20reading%20a%20book%2C%20warm%20colors%2C%20simple%20flat%20design%2C%20friendly%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-01&orientation=squarish',
    text: '43423漫画网的下拉式阅读体验真的太棒了！再也不用不停点「下一页」了，滑一下就能接着看，追漫效率翻倍，强烈推荐给所有漫画爱好者！',
    time: '2小时前',
    likes: '328',
  },
  {
    id: 2,
    name: '追漫少女',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cute%20cartoon%20avatar%20of%20a%20girl%20with%20pink%20hair%2C%20warm%20colors%2C%20simple%20flat%20design%2C%20smiling%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-02&orientation=squarish',
    text: '韩漫资源超级全！《秘密教学》《我独自升级》这些热门韩漫这里都有，而且是下拉式的，看起来特别舒服。每天必刷的漫画网站！',
    time: '5小时前',
    likes: '256',
  },
  {
    id: 3,
    name: '二次元老司机',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cool%20cartoon%20avatar%20of%20an%20otaku%20character%2C%20warm%20colors%2C%20simple%20flat%20design%2C%20confident%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-03&orientation=squarish',
    text: '从日漫到国漫，分类齐全，更新速度快。下拉式阅读这个模式真的上瘾，一口气看了几十话停不下来。绿色无广告这点也很加分！',
    time: '昨天',
    likes: '189',
  },
  {
    id: 4,
    name: '深夜追更人',
    avatar: 'https://readdy.ai/api/search-image?query=A%20sleepy%20cartoon%20avatar%20of%20a%20person%20with%20moon%20background%2C%20warm%20colors%2C%20simple%20flat%20design%2C%20tired%20but%20happy%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-04&orientation=squarish',
    text: '夜间模式简直是熬夜党的福音！晚上躺床上用下拉式追漫太享受了，画面清晰加载快，已经安利给身边所有朋友了。',
    time: '昨天',
    likes: '142',
  },
  {
    id: 5,
    name: '漫画翻译君',
    avatar: 'https://readdy.ai/api/search-image?query=A%20cartoon%20avatar%20of%20a%20translator%20with%20pen%20and%20paper%2C%20warm%20colors%2C%20simple%20flat%20design%2C%20focused%20expression%2C%20clean%20background&width=80&height=80&seq=avatar-05&orientation=squarish',
    text: '作为一个漫画翻译，43423漫画网的下拉式排版对我们来说也很友好。平台画质保持得很好，读者体验优秀，是值得信赖的漫画阅读平台。',
    time: '2天前',
    likes: '97',
  },
];

export default function CommentsSection() {
  return (
    <section id="comments" className="py-16 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100/80 text-secondary-700 text-xs font-medium mb-3">
            读者评价
          </span>
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950">漫友们的真实评价</h2>
          <p className="mt-2 text-foreground-600 text-sm md:text-base">听听下拉式漫画读者怎么说43423漫画网</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {COMMENTS.slice(0, 3).map((comment) => (
            <div key={comment.id} className="p-5 md:p-6 rounded-2xl bg-background-50">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 md:gap-5 mt-4 md:mt-5">
          {COMMENTS.slice(3, 5).map((comment) => (
            <div key={comment.id} className="p-5 md:p-6 rounded-2xl bg-background-50">
              <div className="flex items-center gap-3 mb-4">
                <div className="w-10 h-10 rounded-full overflow-hidden bg-background-200 flex-shrink-0">
                  <img src={comment.avatar} alt={comment.name} className="w-full h-full object-cover" loading="lazy" />
                </div>
                <div>
                  <div className="text-sm font-bold text-foreground-900">{comment.name}</div>
                  <div className="text-xs text-foreground-500">{comment.time}</div>
                </div>
              </div>
              <p className="text-sm text-foreground-700 leading-relaxed mb-3">{comment.text}</p>
              <div className="flex items-center gap-1 text-xs text-foreground-500">
                <i className="ri-thumb-up-line"></i>
                <span>{comment.likes}</span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}